export const TAX_TYPE_OPTIONS = [
  { value: "percentage", label: "Percentage" },
  { value: "absolute", label: "Fixed" },
];

export const taxTypeLabel = (type) =>
  TAX_TYPE_OPTIONS.find((o) => o.value === type)?.label ?? type;

export const formatTaxValue = (tax, currencyCode) => {
  if (tax.value === null || tax.value === undefined) return "—";
  const n = Number(tax.value);
  if (tax.type === "percentage") return `${n}%`;
  const amount = n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return currencyCode ? `${amount} ${currencyCode}` : amount;
};